type BusinessMetadataInput = {
  title?: string | null
  favicon?: string | null
}

const setLinkHref = (selector: string, href: string) => {
  const node = document.querySelector(selector)
  if (node) {
    node.setAttribute('href', href)
    return
  }

  const link = document.createElement('link')
  if (selector.includes('apple-touch-icon')) {
    link.setAttribute('rel', 'apple-touch-icon')
  } else {
    link.setAttribute('rel', 'icon')
  }
  link.setAttribute('href', href)
  document.head.appendChild(link)
}

export const applyBusinessMetadata = ({ title, favicon }: BusinessMetadataInput) => {
  if (title && title.trim() !== '') {
    document.title = title
  }

  if (favicon && favicon.trim() !== '') {
    setLinkHref('link[rel="icon"]', favicon)
    setLinkHref('link[rel="apple-touch-icon"]', favicon)
  }
}
